import * as _ from 'lodash';
import {
  SET_FORM_VALUE,
  SEND_FORM_ORDER,
  formModelActions,
  IRemoveAction,
  REMOVE_FILE,
  flipIsSendingFlagAction,
  FLIP_IS_SENDING_FLAG,
} from '../Actions';
import {
  ESERVICE_MENU_DELETE,
  ESERVICE_MENU_SAVE,
  ESERVICE_MENU_SAVE_CLOSE,
  eserviceMenuActions,
} from 'sos-eservice-common/js/components/EServiceFormMenu/eservicemenu.actions';
import { saveOrder, deleteOrder, sendOrder } from '../../services/formModel.service';
import { setupAutoSave } from '../../services/autoSave.service';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FormField } from 'sos-common/js/commonTypes/formField.types';

type possibleActions = formModelActions | eserviceMenuActions | IRemoveAction;

function setFormFields(state: {}, field: FormField<any> | Array<FormField<any>>): {} {
  const newState = { ...state };
  if (Array.isArray(field)) {
    field.forEach((element) => {
      setValueByKey(newState, element);
    });

    return newState;
  } else {
    return setValueByKey(newState, field);
  }
}

function setValueByKey(state: {}, field: FormField<any>): {} {
  const path = field.fieldName.replace('CurrentResearchOrder.', '').replace('StatisticsOrder.', '').split('.');
  _.set(state, path, field.value);

  return state;
}

function removeFileFromState(state: {}, payload: FileExtendedDetails) {
  const idToRemove = payload.FileId;
  const newState = { ...state };
  const obj = traverseAndRemove(newState, idToRemove);
  return obj;
}

function traverseAndRemove(obj: {}, fileId) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (key === 'FileId' && obj[key] === fileId) {
        obj[key] = null;
      }
      if (typeof obj[key] === 'object') {
        obj[key] = traverseAndRemove(obj[key], fileId);
      }
    }
  }
  return obj;
}

export function redirect(url: string) {
  return function () {
    window.location.href = url;
  };
}

export function formModel(state = {}, action: possibleActions, store: FormBaseStore<any>) {
  switch (action.type) {
    case SET_FORM_VALUE:
      setupAutoSave();
      return setFormFields(state, action.payload);
    // case ESERVICE_MENU_SAVE:
    //   saveOrder(state, store.globals.orderId);
    //   return state;
    // case ESERVICE_MENU_SAVE_CLOSE:
    //   saveOrder(state, store.globals.orderId).then(
    //     redirect(store.globals.homePageUrl)
    //   );
    //   return state;
    case ESERVICE_MENU_DELETE:
      deleteOrder(store.globals.orderId).then(redirect(store.globals.homePageUrl));
      return state;
    // case SEND_FORM_ORDER:
    //   sendOrder(
    //     state,
    //     store.registers,
    //     store.globals.orderId,
    //     store.files
    //   ).then(redirect(store.globals.thankYouPageUrl));
    //   return state;
    case REMOVE_FILE:
      return removeFileFromState(state, action.payload);
    default:
      return state;
  }
}
